import { gql } from 'graphql-tag';
import {
  useMutation,
  MutationTuple,
  MutationHookOptions,
} from '@apollo/client';
import {
  CheckIntoSelfRegisteredVisitFromArrivalDisplayMutation,
  CheckIntoSelfRegisteredVisitFromArrivalDisplayMutationVariables,
} from './__generated__/useCheckInSelfRegVisit.generated';

const CHECK_IN_MUTATION = gql`
  mutation CheckIntoSelfRegisteredVisitFromArrivalDisplay($guestInviteId: ID!) {
    checkIntoSelfRegisteredVisitFromArrivalDisplay(
      guestInviteId: $guestInviteId
    )
  }
`;

/**
 * Checks in a visit that was self-registered on the Arrival Display.
 *
 * For checking in visits created in advance, use `useCheckInPreRegVisit`
 */
export const useCheckInSelfRegVisit = (
  options?: MutationHookOptions<
    CheckIntoSelfRegisteredVisitFromArrivalDisplayMutation,
    CheckIntoSelfRegisteredVisitFromArrivalDisplayMutationVariables
  >
): MutationTuple<
  CheckIntoSelfRegisteredVisitFromArrivalDisplayMutation,
  CheckIntoSelfRegisteredVisitFromArrivalDisplayMutationVariables
> => {
  return useMutation<
    CheckIntoSelfRegisteredVisitFromArrivalDisplayMutation,
    CheckIntoSelfRegisteredVisitFromArrivalDisplayMutationVariables
  >(CHECK_IN_MUTATION, options);
};
